var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.href ? 'a' : 'button',_vm._b({ref:"btn",tag:"component",staticClass:"vue-button",class:[
    _vm.type ? 'vue-button--' + _vm.type : '',
    _vm.size ? 'vue-button--' + _vm.size : '',
    _vm.additionalType ? 'vue-button--' + _vm.additionalType : '',
    {'vue-button--disabled': _vm.isDisabled},
    {'vue-button--full': _vm.fullWidth},
    {'vue-button--without-border': _vm.withoutBorder}
  ],attrs:{"disabled":_vm.isNativeDisabled,"target":_vm.computedTarget,"type":_vm.nativeType},on:{"click":function($event){_vm.cancelAutoScroll && _vm.$refs.btn.blur()}}},'component',_vm.href ? { 'href': _vm.href } : '',false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }